import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { __ } from 'react-i18n';
import * as closeSrc from '../../../../assets/zemplin/close.svg';
import { Input } from '../General/Input';
import { prop } from '../../../utilities';

interface Props {
  handleChange: (goodId, value) => void;
  goodId: number;
  defaultValue: string;
}

function OrderNrInput({ handleChange, defaultValue, goodId }: Props) {
  const [orderNr, setOrderNr] = React.useState(defaultValue || '');

  const handleBlur = e => {
    handleChange(goodId, e.target.value);
  };

  const handleReset = () => {
    handleChange(goodId, '');
    setOrderNr('');
  };

  const handleOrderNrChange = e => {
    setOrderNr(e.target.value);
  };

  const showIcon = orderNr && orderNr.length > 0;

  return (
    <>
      <Wrapper>
        <StyledInput
          onChange={handleOrderNrChange}
          onBlur={handleBlur}
          value={orderNr}
          type="text"
          name="ordernr"
        />
        {showIcon ? (
          <ResetIcon onClick={handleReset} src={closeSrc.toString()} />
        ) : null}
      </Wrapper>
      <OrderNumber>{defaultValue}</OrderNumber>
    </>
  );
}

const Wrapper = styled.div`
  position: relative;
  width: fit-content;
  margin-right: auto;

  ${({ theme }) => theme.mediab.m810`
      display: none;
  `}
`;

const OrderNumber = styled.span`
  display: none;
  line-height: ${rem(16)};
  font-size: ${rem(12)};
  font-family: ${({ theme }) => theme.font.tertiary};
  color: ${({ theme }) => theme.colors.placeholder};
  margin-right: auto;
  margin-bottom: ${rem(24)};

  ${({ theme }) => theme.mediab.m810`
      display: block;
  `}
`;

const ResetIcon = styled.img`
  position: absolute;
  cursor: pointer;
  right: ${rem(12)};
  top: ${rem(10)};
  width: ${rem(16)};
  height: ${rem(16)};
`;

const StyledInput = styled(Input)`
  max-width: ${rem(166)};
  width: 100%;
  height: ${rem(32)};
  margin-right: auto;
  margin-bottom: ${rem(14)};
  color: ${({ theme }) => theme.colors.black};
`;

export { OrderNrInput };
